export default "__VITE_ASSET__BokDDVL7__"